import { useContext } from "react";
import PermissionContext from "../contexts/PermissionContext";
import { checkForPermissionLevel } from "../helpers/permissions";

/**
 * Hook to check if the user is locked to the apps section
 * @returns appsLocked, isLoading
 */
export function useAppsPermission() {
  const permissions = useContext(PermissionContext);
  const isLocked = checkForPermissionLevel(permissions, "APPS", "MISC");
  return {
    appsLocked: isLocked,
    isLoading: permissions.isLoading,
  };
}
